<template>
  <modal ref='modal'>
    <template #header>
      <h5 class="modal-title mt-0">
        {{ $t('contacts.bulk.create_folders')}}
      </h5>
    </template>

    <template #body>
      <form @submit.prevent="bulkCreateFolders()">
        <div class="modal-body">
          <div class="form-group">
            <label class="col-form-label">
              {{ $t('folders.add_modal.folder_name')}}
            </label>

            <input type="text" name='folder_name' class="form-control" required="required" v-model='folderName' />
          </div>

          <div class="form-group">
            <label class="col-form-label">
              {{ $t('root.add_parent')}}
            </label>

            <div>
              <single-select :template='folderTemplate' :getter='getFolders' name='folder_id' v-model='folderParent' />
            </div>
          </div>

          <div class="form-group">
            <label class="col-form-label">
              {{ $t('contacts.bulk.created_for')}}
            </label>

            <div>
              <ul v-for="c in contacts" :key='c.id'>
                <li>{{c.name}}</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <input type="submit" name="commit" :value="$t('folders.add_modal.save')" class="btn btn-primary float-right" :disabled='isProcessing'>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import _modal from '../_modal'
import _single_select from '../shared/_infinite_single_select'

export default {
  components: {
    modal: _modal,
    'single-select': _single_select
  },
  data() {
    return {
      folderName: '',
      contacts: [],
      folderParent: {},
      isProcessing: false,
    }
  },
  methods: {
    open(contacts) {
      this.folderName = ''
      this.folderParent = {}
      this.contacts = contacts

      this.$refs.modal.open()
    },
    getFolders(params) {
      return this.listStore.getFolders(params)
    },
    bulkCreateFolders(){
      this.isProcessing = true
      const contact_ids = (this.contacts || []).map(c => c.id)

      let paramsFolders = {
        contact_ids: contact_ids,
        folder_id: this.folderParent.id,
        name: this.folderName
      }

      this.store.bulkCreateFolders(paramsFolders).then(() => {
        this.$emit('success')
        this.$toastr.success(this.$t('contacts.bulk.success'))
        this.$refs.modal.close()
      }).finally(() => {
        this.isProcessing = false
      })
    }
  }
}
</script>

<style lang='sass' scoped>
p
  font-size: 12px
</style>

